module.exports = __webpack_public_path__ + "static/media/email.d4a2024f.svg";